/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
import { action } from '@ember/object';
import Component from '@ember/component';

export default class XeroErrorDialog extends Component {
  closeErrorDialog() {}

  @action
  handleCloseErrorDialog() {
    this.closeErrorDialog();
  }
}
